<template>
  <!-- 登录页 -->
  <div class="vip-main">
    <header-general :isWhite="true" type="login" @changeLoginShow="changeLoginShow" />
    <login-box v-show="isShow" @changeLoginShow="changeLoginShow" />
    <div class="banner"></div>
    <div class="box1">
     <div class="public clearfix">
       <div class="box1-top">
         <h2>高级特权，值得尊享</h2>
         <p>造价云管理平台提供超大容量空间、计价、算量工程在线预览、数据审核、设置最佳组价等特权。</p>
         <div class="imgbox">
           <img src="~@/assets/images/indexpage/vip/privilege.png" width="100%" />
         </div>
       </div>
     </div>
    </div>
    <div class="box2">
     <div class="public">
       <div class="title">套餐特权</div>
       <div class="tq-text">套餐仅适用于企业客户</div>
       <div class="item">
         <img src="~@/assets/images/indexpage/vip/img-01.jpg" />
       </div>
       <!-- <div class="item">
         <img src="~@/assets/images/indexpage/vip/img-02.jpg" />
       </div> -->
       <div class="item">
         <img src="~@/assets/images/indexpage/vip/img-03.jpg" />
       </div>
     </div>
    </div>
    <div class="fbox">
     <div class="public goumai-f">
       <div class="title">价格及购买</div>
       <div class="goumai-ftext">
         请联系
         <span>当地销售人员</span>咨询套餐价格并为您下单，您也可以咨询客服：4000-166-166
       </div>
     </div>
    </div>
    <footer-general type="blocked" />
    <w-backtotop :visibility-height="100" iconName="w-icon-sanjiao-copy2" :custom-style="backToTopCustomStyle" ref="backToTop"></w-backtotop>
  </div>
</template>
<style lang="less" type="text/less">
	@import 'index.less';
  .vip-main{
    h1, h2, h3, h4, h5, h6, p, address, ol, ul, dl{
      margin-bottom: 0;
    }
    width: 100%;
    min-width: 1280px;
    text-align: center;
    padding-top: 72px;
    .fbox{
      text-align: left;
      .goumai-f{
        .title{
          font-size: 28px;
          color: #fff;
          height: 36px;
          line-height: 36px;
          border-left: 8px solid #fd3a54;
          padding-left: 18px;
        }
      }
    }
    .box2{
      text-align: left;
      .public{
        .title{
          font-size: 28px;
          color: #3f3f3f;
          height: 36px;
          line-height: 36px;
          border-left: 8px solid #fd3a54;
          padding-left: 18px;
        }
      }
    }
  }
</style>
<script>
import windowResizeMixin from '@/assets/mixins/window-resize'
import documentScrollMixin from '@/assets/mixins/document-scroll'
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import LoginBox from '_c/PageIndex/Login/IndexNew.vue'
import FooterGeneral from '_c/common/Footer/FooterGeneral.vue'
export default {
  name: 'IndexPage',
  components: {
    HeaderGeneral,
    LoginBox,
    FooterGeneral
  },
  mixins: [windowResizeMixin, documentScrollMixin],
  data () {
    return {
      footerMarginTop: 50,
      scrollTop: 0,
      qrCodeSrc: require('assets/images/login/r2-qr-code.png'),
      isWhite: false, // 页头是白底的（非透明）
      isShow: false // 是否显示登陆框
    }
  },
  mounted () {
    this.isShow = (this.$route.query.willLogin === 'true')
    this.initEvent()
  },
  methods: {
    // 1.0 初始化事件
    initEvent () {
      this.computeHeight()
      this.resizeHandle.resize(() => {
        this.computeHeight()
      })
      this.computeScrollTop()
      this.scrollHandle.scroll(() => {
        this.computeScrollTop()
      })
    },
    // 1.1 初始化 窗口大小监听
    computeHeight () {
      const windowHeight = document.body ? document.body.clientHeight : (document.documentElement ? document.documentElement.clientHeight : 0)
      if (windowHeight && windowHeight > 920) {
        this.footerMarginTop = windowHeight - 920 + 50
      } else {
        this.footerMarginTop = 50
      }
    },
    // 1.2 计算纵向滚动条位置
    computeScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop){
        scrollTop = document.documentElement.scrollTop
      } else if (document.body){
        scrollTop = document.body.scrollTop
      }
      this.scrollTop = scrollTop
    },
    changeLoginShow (show){
      this.isShow = show
      show && this.$refs.backToTop.backToTop()
    }
  }
}
</script>
